import { em } from 'polished'
import styled from 'styled-components'

import { Text, TextSmallDescr } from 'styles/components/typography'

export const SmallDescr = styled(TextSmallDescr)`
  color: ${p => p.theme.colors.blackOp4};
  width: ${em(230)};
`

export const NormalDescr = styled(Text)`
  width: ${em(250)};
`
